// @flow
import * as React from 'react';
import Theme from '../../themes';

const { borderRadius } = Theme.global;
const { buttons } = Theme.forms;

type Props = {
  id?: ?string,
  title: string | Object,
  type: ?'submit' | 'button',
  isDisabled: ?boolean,
  color: ?string,
  size: ?'small' | 'medium' | 'big',
  borderType: ?'rounded' | 'round',
  icon?: React.Node | Object,
  iconPosition: ?'before' | 'after',
  fullWidth: ?boolean,
  style: ?Object,
  onClick: ?Function,
};

class Button extends React.PureComponent<Props> {
  static defaultProps = {
    id: null,
    type: 'button',
    isDisabled: false,
    color: 'blue',
    size: 'medium',
    borderType: 'rounded',
    icon: null,
    iconPosition: 'before',
    fullWidth: false,
    style: null,
    onClick: () => {},
  };

  render() {
    const {
      id,
      title,
      type,
      isDisabled,
      color,
      style,
      borderType,
      icon,
      iconPosition,
      size,
      fullWidth,
      onClick,
    } = this.props;

    return (
      // eslint-disable-next-line react/button-has-type
      <button
        id={id}
        data-test={id}
        type={type}
        onClick={onClick}
        className={`${color || ''} ${size || ''} ${fullWidth ? 'full-width' : ''}`}
        style={style}
        disabled={isDisabled}
      >
        {icon && iconPosition === 'before' && <span className="iconBefore">{icon}</span>}
        {title}
        {icon && iconPosition === 'after' && <span className="iconAfter">{icon}</span>}
        <style jsx>
          {`
            button {
              border-radius: ${borderType === 'rounded' ? borderRadius : '2em'};
              border: 1px solid;
              vertical-align: middle;
            }
            .small {
              font-size: 0.75em; /* 12/16 */
              padding: 0.5em 0.65em;
            }
            .medium {
              font-size: 1em; /* 16/16 */
              padding: 0.65em;
            }
            .big {
              font-size: 1.125em; /* 18/16 */
              padding: 0.8em 1em;
            }
            .full-width {
              width: 100%;
            }
            .iconBefore {
              margin-right: 5px;
            }
            .iconAfter {
              margin-left: 5px;
            }
            :global(.rtl) .iconBefore {
              margin-left: 5px;
            }
            :global(.rtl) .iconAfter {
              margin-right: 5px;
            }
            .blue {
              background: ${buttons.blue.bg};
              border-color: ${buttons.blue.border};
              color: ${buttons.blue.color};
            }
            .orange {
              background: ${buttons.orange.bg};
              border-color: ${buttons.orange.border};
              color: ${buttons.orange.color};
            }
            .white {
              background: ${buttons.white.bg};
              border-color: ${buttons.white.border};
              color: ${buttons.white.color};
            }
            .gray {
              background: ${buttons.gray.bg};
              border-color: ${buttons.gray.border};
              color: ${buttons.gray.color};
            }
            button:disabled {
              background: ${buttons.disabled.bg};
              border-color: ${buttons.disabled.border};
              color: ${buttons.disabled.color};
            }
            @media (max-width: 320px) {
              button {
                font-size: 0.875em !important; /* 14/16 */
                min-width: 0px !important;
              }
            }
          `}
        </style>
      </button>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./app/common/forms/Button.js